var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'c-progress-top',
    {
      'c-progress-top--active': _vm.isActive,
      'c-progress-top--complete': _vm.isComplete,
    } ]},[_c('span',{style:({ width: _vm.loadProgress + '%' })})])}
var staticRenderFns = []

export { render, staticRenderFns }